import React from "react";
import { Box, Tabs, Tab, Badge } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { selectWipNotificationCount } from "../../selectors/wipNotification.selector";
import { setNotificationTabs } from "../../reducers/notification.reducer";
import { selectNotificationTabs } from "../../selectors/notification.selector";

const NotificationTabs = () => {
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    dispatch(setNotificationTabs(newValue));
  };
  const value = useSelector(selectNotificationTabs);
  const unreadWipNotificationsCount = useSelector(selectWipNotificationCount);

  return (
    <Box sx={{ width: "100%", px: 2, flexGrow: 1 }}>
      <Tabs
        variant="fullWidth"
        value={value}
        onChange={handleChange}
        sx={{ textDecoration: "none" }}
      >
        <Tab
          value="wip"
          label={
            <Badge
              badgeContent={unreadWipNotificationsCount}
              color="error"
              sx={{ "& .MuiBadge-badge": { right: -15 } }}
            >
              WIP Notifications
            </Badge>
          }
          sx={{ textTransform: "none" }}
        />
      </Tabs>
    </Box>
  );
};

export default NotificationTabs;

